import React, { useMemo } from 'react';
import styles from './OrderCard.module.css';
import { formatSymbol } from '../utils/symbolFormatter';
import { isMarketOpen } from '../utils/marketTimeChecker';

const OrderCard = ({ order, onAction, onOpenModify }) => {
  const {
    _id, tradeSymbol, tradeType, quantity, entryPrice,
    orderStatus, orderTime, exchange
  } = order || {};

  // 1. Hooks MUST be at the top level
  const marketStatus = useMemo(() => {
    if (!order) return { isOpen: true, message: '' };
    const type = order.exchange?.toUpperCase() === 'MCX' ? 'commodity' : 'equity';
    return isMarketOpen(type);
  }, [order]);

  // 2. Early return AFTER hooks
  if (!order) return null;

  const handleAction = (type) => {
    if (onAction) onAction(type, _id);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '--';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const time = date.toLocaleTimeString('en-IN', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: true
    }).toLowerCase();
    return `${day}/${month} ${time}`;
  };

  return (
    <div className={styles.orderCard}>
      <div className={styles.cardHeader}>
        <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
          <h4 className={styles.symbolName}>{formatSymbol(tradeSymbol)}</h4>
          <span className={`${styles.tradeType} ${styles[tradeType.toLowerCase()]}`}>{tradeType.toUpperCase()}</span>
          <span className={styles.exchangeBadge}>{exchange}</span>
        </div>
        <span className={`${styles.statusBadge} ${styles['status-' + orderStatus.toLowerCase()]}`}>{orderStatus}</span>
      </div>

      <div className={styles.detailsRow}>
        <div className={styles.detailItem}>
          <span className={styles.label}>Qty</span>
          <span className={styles.value}>{quantity}</span>
        </div>
        <div className={styles.detailItem}>
          <span className={styles.label}>Price</span>
          <span className={styles.value}>₹{(entryPrice || 0).toFixed(2)}</span>
        </div>
        <div className={styles.detailItem} style={{textAlign: 'right'}}>
          <span className={styles.label}>Time</span>
          <span className={styles.value}>{formatDate(orderTime)}</span>
        </div>
      </div>

      {!marketStatus.isOpen && orderStatus === 'Pending' && (
        <div style={{fontSize: '0.7rem', color: 'var(--secondary-color)', marginTop: '4px', fontWeight: 600}}>
          {marketStatus.message}
        </div>
      )}

      {orderStatus === 'Pending' && (
        <div className={styles.orderActions}>
          <button 
            onClick={(e) => {e.stopPropagation(); if(onOpenModify) onOpenModify(order)}} 
            className={styles.btnModify}
            disabled={!marketStatus.isOpen}
          >
            Modify
          </button>
          <button 
            onClick={(e) => {e.stopPropagation(); handleAction('cancel')}} 
            className={styles.btnCancel}
            disabled={!marketStatus.isOpen}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};

export default OrderCard;
